/**
 * Hook: Step click handler for wizard navigation.
 * Single Responsibility: resolve step number to route and navigate; respect feature flag for step 3.
 */

import { useCallback } from 'react';
import { STEP_ROUTES } from '../constants';

/**
 * Pure: get route for a step number (or fallback path).
 * @param {number} stepNumber
 * @returns {string}
 */
export function getStepRoute(stepNumber) {
  return STEP_ROUTES[stepNumber] ?? `/wizard/step-${stepNumber}`;
}

export function useStepNavigation(wizardStatus, cleaningStandardsEnabled, navigate) {
  const handleStepClick = useCallback(
    (stepNumber) => {
      if (!wizardStatus) return;

      const step = wizardStatus.steps?.find((s) => s.step === stepNumber);
      if (!step || !step.isEnabled) return;

      if (stepNumber === 3 && !cleaningStandardsEnabled) return;

      navigate(getStepRoute(stepNumber));
    },
    [wizardStatus, cleaningStandardsEnabled, navigate],
  );

  return { handleStepClick };
}
